/** 关闭插件菜单事件 */
export const PLUGIN_CLOSE_EVENT = 'PLUGIN_CLOSE_EVENT';
/** 打开插件菜单事件 */
export const PLUGIN_OPEN_EVENT = 'PLUGIN_OPEN_EVENT';

/** 使用ai扩图 */
export const USE_AI_EXPEND_IMAGE = 'aiExpendImage';

// 使用ai改图
export const USE_AI_MODIFY_IMAGE = 'aiModifyImage';

// 图片翻译
export const IMAGE_TRANSLATION = 'image_translation';
// 图片翻译输入框改变写入历史记入
export const IMAGE_TRANS_INPUT_CHANGE_HISTORY = 'image-trans-input-change-history';
// 图片翻译历史
export const IMAGE_TRANS_HISTORY = 'image_trans_history';
